import { tw } from "twind";
import React from "react";
import { useCartStore } from "../../store/cart";

interface PromoMessageProps {
  onPromoMessageClick: () => void;
}

export const PromoMessage = ({ onPromoMessageClick }: PromoMessageProps) => {
  const {cart, theme} = useCartStore();

  if (!cart || !cart.promo_message) return null;

  if (!cart.popup_discounts) {
    return <div className={tw`p-2 mb-4 bg-${theme} text-white w-full max-w-3xl text-sm text-center`}>
      { cart.promo_message }
    </div>
  }

  return <div
    className={tw`p-2 mb-4 bg-${theme} text-white w-full max-w-3xl text-sm text-center cursor-pointer`}
    onClick={onPromoMessageClick}
  >
    { cart.promo_message }
  </div>
}
